export default "/assets/images/the-mama-to-be.db719a203ff1f103.webp";